import Main from '../pages/Account/Main'
import Entry from '../pages/Account/Entry'
import Step1 from '../pages/Account/Step1'
import Step2 from '../pages/Account/Step2'
import Step3 from '../pages/Account/Step3'

export default [
    {
        path: '',
        redirect: 'home'
    },
    {
        path: 'home',
        component: Main
    },
    {
        path: 'entry',
        component: Entry,
        children: [
            {
                path: '',
                redirect: 'step1'
            },
            {
                name: 'x0',
                path: 'step1',
                component: Step1
            },
            {
                name: 'x1',
                path: 'step2',
                component: Step2
            },
            {
                name: 'x2',
                path: 'step3',
                component: Step3
            }
        ]
    }
]
